import { render, staticRenderFns } from "./TxnModal.vue?vue&type=template&id=596bb63a&"
import script from "./TxnModal.vue?vue&type=script&lang=js&"
export * from "./TxnModal.vue?vue&type=script&lang=js&"
import style0 from "./TxnModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports